import {useThemes} from "../../style/themes.hook";
import {graphql, useStaticQuery} from "gatsby";
import {ThemeProvider} from "styled-components";
import {Heading4, MaxWidthContainer, Paragraph} from "../../style/itf-styled-components";
import Img from "gatsby-image/withIEPolyfill";
import {FestivalCategory} from "../festival-category";
import React from "react";
import {Section} from "./section";
import {useYoumembers} from "../../data/hooks/members";
import {MembersAvatarList} from "../members-avatar-list";

export const YouimagineSection = () => {
  const themes = useThemes();
  const images = useStaticQuery(graphql`
        query youImagine {
          youimage: file(relativePath: { eq: "casual-man-watching-photo-expo.png" }) {
            childImageSharp {
              fluid(maxWidth: 2000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }`
  );

  return (
    <ThemeProvider theme={themes.light}>
      <MaxWidthContainer
        as={Section}
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 100px;

          @media (max-width: ${props => props.theme.mobileWidth}) {
            display: flex;
            flex-direction: column-reverse;
          }
        `}
      >
        <div
          css={`
            display: flex;
            justify-content: flex-start;

            @media (max-width: ${props => props.theme.mobileWidth}) {
              justify-content: center;
              margin-top: 50px;
            }
          `}
        >
          <Img
            css={`
              width: 100%;
              max-width: 424px;
            `}
            fluid={images.youimage.childImageSharp.fluid}
            objectPosition="50% top"
          />
        </div>
        <div>
          <span css={`font-size: 2em;`}>
            <FestivalCategory category={"you"}/>
          </span>
          <Heading4>Fotografie non-wedding</Heading4>
          <Paragraph>Fotografia newborn, fotografia de stradă, de peisaj, cea realizată cu dispozitive mobile, fotografia glam-fashion și cea de produs - fiecare în parte este o lume fascinantă cu reguli proprii. Descoperiți tehnicile de bază și secretele domeniului de la nume îndrăgite din fotografia autohtonă, în cadrul secțiunii YouImagine.</Paragraph>
        </div>
      </MaxWidthContainer>
      <MaxWidthContainer
        as={Section}
        css={`
          padding-bottom: 100px;
          padding-top: 0;
        `}
      >
        <MembersAvatarList speakers={useYoumembers()}/>
      </MaxWidthContainer>
    </ThemeProvider>
  );
}